import { motion } from 'framer-motion';
import type { LaneCommitment, Lane, CardDefinition, Faction } from '../../types/kotch';
import { LANES } from '../../types/kotch';
import Card from './Card';
import { LANE_SHORT_NAMES } from '../../data/kotch/gameConstants';
import { FACTION_INFO } from '../../data/kotch/factionDecks';

interface CommitZoneProps {
  commitment: LaneCommitment;
  isOpponent?: boolean;
  onSlotClick?: (lane: Lane) => void;
  canInteract?: boolean;
  selectedCardId?: string | null;
  playerFaction?: Faction | null;
  onCardHover?: (def: CardDefinition | null) => void;
}

export default function CommitZone({
  commitment,
  isOpponent = false,
  onSlotClick,
  canInteract = false,
  selectedCardId,
  playerFaction,
  onCardHover,
}: CommitZoneProps) {
  const factionInfo = playerFaction ? FACTION_INFO[playerFaction] : null;

  return (
    <div
      className={`kotch-commit-zone ${factionInfo ? 'faction-accented' : ''}`}
      style={factionInfo ? { '--faction-color': factionInfo.themeColor } as React.CSSProperties : undefined}
    >
      {LANES.map((lane) => {
        const card = commitment[lane];
        const isOccupied = card !== null;
        const isDroppable = canInteract && !isOccupied && selectedCardId !== null;

        return (
          <motion.div
            key={lane}
            className={`kotch-commit-slot ${isOccupied ? 'occupied' : ''} ${isDroppable ? 'droppable' : ''}`}
            onClick={() => {
              if (canInteract && onSlotClick) {
                onSlotClick(lane);
              }
            }}
            whileHover={isDroppable ? { scale: 1.05 } : {}}
          >
            {card ? (
              <Card
                card={card}
                faceUp={!isOpponent}
                size="small"
                playerFaction={playerFaction}
                onHover={onCardHover}
                onClick={() => {
                  if (canInteract && onSlotClick) {
                    onSlotClick(lane);
                  }
                }}
              />
            ) : (
              <span className="kotch-commit-slot-label">
                {LANE_SHORT_NAMES[lane]}
              </span>
            )}
          </motion.div>
        );
      })}
    </div>
  );
}
